import { render, staticRenderFns } from "./dialogAdministrador.vue?vue&type=template&id=e4248d8e&scoped=true"
import script from "./dialogAdministrador.vue?vue&type=script&lang=js"
export * from "./dialogAdministrador.vue?vue&type=script&lang=js"
import style0 from "./dialogAdministrador.vue?vue&type=style&index=0&id=e4248d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4248d8e",
  null
  
)

export default component.exports